import SelectTaxVatIn from "./SelectTaxVatIn.vue";
import SelectTaxVatOut from "./SelectTaxVatOut.vue";

export { SelectTaxVatIn, SelectTaxVatOut };
